import { render, staticRenderFns } from "./VersionWeb.vue?vue&type=template&id=67f26558&scoped=true"
import script from "./VersionWeb.vue?vue&type=script&lang=js"
export * from "./VersionWeb.vue?vue&type=script&lang=js"
import style0 from "./VersionWeb.vue?vue&type=style&index=0&id=67f26558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f26558",
  null
  
)

export default component.exports